import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const DocumentEmptyRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const Description = styled.h3`
  ${typographyV2.titleBase}
`;
